import React from "react";

import { CheckCircle } from "@mui/icons-material";
import { Backdrop, Box, Button, Fade, Modal, Typography } from "@mui/material";


const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: { md: "34vw", xs: "90vw" },
  height: "auto",
  overflow: "hidden",
  scrollbarWidth: "thin",
  "&::-webkit-scrollbar": {
    width: "0.15em",
    borderRadius: 50,
  },
  "&::-webkit-scrollbar-track": {
    background: "transparent",
  },
  "&::-webkit-scrollbar-thumb": {
    backgroundColor: "transparent",
  },
  "&::-webkit-scrollbar-thumb:hover": {
    background: "transparent",
  },
  bgcolor: "background.paper",
  boxShadow: 24,
  outline: "none",
  borderRadius: "20px",
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  p: 5,
  gap: 1,
};

const SuccessModal = ({ open, icon, title, description, btnText, onBtnClick, onClose }) => {
  return (
    <Modal
      open={open}
      onClose={onClose}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 500,
      }}
    >
      <Fade in={open}>
        <Box sx={style}>
          {icon || <CheckCircle sx={{ width: '80px', height: '80px', color: '#37D46C' }} />}
          <Typography fontSize="35px" fontWeight={500} textAlign="center">
            {title || "Interview Created"}
          </Typography>
          <Typography fontSize="16px" fontWeight={500} color="#898989" textAlign="center">
            {description ||
              "You can use this interview in your job post for get number of potential candidates, their cv will be conducted by link and rest is handle by getgeek"}
          </Typography>
          <Button variant="main" sx={{ px: 3, mt: 4, fontSize: '18px' }} onClick={onBtnClick}>
            {btnText || "Continue"}
          </Button>
        </Box>
      </Fade>
    </Modal>
  );
};

export default SuccessModal;
